export default {
  title: 'Najpopularniejsze',
  columns: {
    name: 'Nazwa',
    quantity: 'Ilość',
    amount: 'Kwota',
  },
};
